import {
    reqCyNewMsg,
    reqCyYBKVipState,
    reqCyGetPoints,
    reqCyUserInfo,
    reqCyGetCouponQuantity,
    reqCyGetEcardQuantity,
    reqCyGetRightsQuantity,
    reqCyGardenSwitch,
    reqCyUserRegisterTime,
    reqCyGardenSignData
} from 'changyo-public-api'
import requestApi from 'changyo-public-api/src/libs/requestApi'
import { GET_ORDER_LIST } from './mutation-types'

export default {
  queryOrderList({commit, state}, data){
      commit(GET_ORDER_LIST, {data})
  },
  async hasNewMsg({ commit, state }) {
    if (state.token) {
      const res = await reqCyNewMsg({
        login_token: state.token
      }).catch(() => {
        commit('setNewMsgState', 0)
      })

      if (res && res.data) {
        commit('setNewMsgState', Number(res.data.hasMsg) || 0)
      }
    } else {
      commit('setNewMsgState', 0)
    }
  },
  async isVip({ commit, state }) {
    if (state.token) {
      const res = await reqCyYBKVipState({
        login_token: state.token,
        vipCode: 'changyoVip'
      }).catch(() => {
        commit('setVipState', false)
      })

      if (res && res.data) {
        commit('setVipState', res.data.isVip || false)
      }
    } else {
      commit('setVipState', false)
    }
  },
  async getPoints({ commit, state }) {
    if (state.token) {
      const res = await reqCyGetPoints({
        login_token: state.token
      }).catch(() => {
        commit('setPoints', 0)
        commit('setSoonExpiredPoints', 0)
      })

      if (res && res.data) {
        commit('setPoints', res.data.points || 0)
        commit('setSoonExpiredPoints', res.data.soonExpiredPoints || 0)
      }
    } else {
      commit('setPoints', 0)
      commit('setSoonExpiredPoints', 0)
    }
  },
  async getUserInfo({ commit, state }) {
    if (state.token) {
      const res = await reqCyUserInfo({
        login_token: state.token
      })

      if (res && res.data) {
        const data = res.data.data

        if (data) {
          if (data.imageUrl && data.imageUrl.length > 5) {
            commit('setUserAvatar', '/' + data.imageUrl)
          }
          commit('setUserMobile', data.mobileNo)
          commit('setUserSensitiveMobile', data.mobileNo.replace(/^(\d{3})\d*(\d{4})$/, '$1****$2'))
          commit('setUserNickname', data.nickname)
        }
      }
    }
  },
  async getCouponQuantity({ commit, state }) {
    if (state.token) {
      const res = await reqCyGetCouponQuantity({
        login_token: state.token,
        source: state.channel
      })

      if (res && res.data) {
        const data = res.data

        if (data) {
          commit('setCouponQuantity', data.couponNum || 0)
        }
      }
    }
  },
  async getEcardQuantity({ commit, state }) {
    if (state.token) {
      const res = await reqCyGetEcardQuantity({
        login_token: state.token
      })

      if (res && res.data) {
        const data = res.data

        if (data) {
          commit('setEcardQuantity', data.ecardCount || 0)
        }
      }
    }
  },
  async getappid({ commit }) {
    if (window.__wxjs_environment == 'miniprogram') {
      commit('setappid', 'h5')
      commit('setmsgVersion', '1.0.0')
    }
    else if (/(MicroMessenger)/i.test(navigator.userAgent)) {
      commit('setappid', 'h5')
      commit('setmsgVersion', '1.0.0')
    }
    else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      commit('setappid', 'app')
      commit('setmsgVersion', '5.5.0')
    }
    else if (/(Android)/i.test(navigator.userAgent)) {
      commit('setappid', 'app')
      commit('setmsgVersion', '5.5.0')
    }
    else{
      commit('setappid', 'h5')
      commit('setmsgVersion', '1.0.0')
    }
  },
  async getRightsQuantity({ commit, state }) {
    if (state.token) {
      const res = await reqCyGetRightsQuantity({
        login_token: state.token,
        usestate: '0'
      })

      if (res && res.data) {
        const data = res.data

        if (data) {
          commit('setRightsQuantity', data.num || 0)
        }
      }
    }
  },
  async getGardenSwitch({ commit, state }) {
    const res = await reqCyGardenSwitch()

    if (res && res.data) {
      const data = res.data

      if (data) {
        commit('setGardenEntrance', data.entrance || false)
        commit('setGardenPop', data.popup || false)

        if (data.entrance && state.token) {
          const res1 = await requestApi('/poseidon/garden/api/v1_0/remind', {
            appCode: state.channel,
            isClick: !!state.gardenGuide,
            loginToken: state.token
          }, {
            wrapperData: true,
            headers: {
              'Content-Type': 'application/json'
            }
          })

          if (res1 && res1.data) {
            commit('setGardenGuideDisplay', res1.data.show)
          }
        }
      }
    }
  },

  async isNewUser({ commit, state }) {
    if (state.token) {
      const res = await reqCyUserRegisterTime({
        login_token: state.token
      })

      if (res && res.data) {
        const data = res.data

        if (data && data.intime) {
          const limitTime = 3 * 24 * 3600 * 1000
          const thisDate = new Date().getTime()
          const flag = (thisDate - data.intime) < limitTime

          commit('setNewUser', flag)
        }
      }
    }
  },

  async isGardenSigned({ commit, state }) {
    if (state.token) {
      const res = await reqCyGardenSignData({
        loginToken: state.token
      })

      if (res && res.data) {
        const data = res.data.taskList
        const item = data[0]
        const flag = item ? item.status === 0 : false

        commit('setGardenSigned', !flag)
      }
    }
  }
}
